import RouteResetController from 'donor-elf-web/lib/route-reset-controller';
import { service } from '@ember/service';
import { get, set } from '@ember/object';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validatePresence } from 'ember-changeset-validations/validators';

const validation = {
  templateId: validatePresence({ presence: true, message: "Can't be blank" }),
  name: validatePresence({ presence: true, message: "Can't be blank" }),
};

export default RouteResetController.extend({
  abilities: service(),
  coachingService: service(),
  navbarSettings: service(),
  store: service(),

  beforeModel(transition) {
    if (this.abilities.noCoachingAbility('create_individual')) {
      transition.abort();
      return;
    }
    set(this, 'navbarSettings.title', 'Add Individual');
    this.coachingService.clearSelectedIndividual();
  },

  model() {
    return this.abilities.loadCoachingAbilities().then(() => {
      return this.store
        .query('coaching/individual', { filter: { template: true } })
        .then((templates) => {
          return {
            templates,
            changeset: new Changeset(
              {},
              lookupValidator(validation),
              validation,
            ),
          };
        });
    });
  },
});
